// Info Row Component
export const InfoRow = ({ label, value, icon: Icon }) => (
  <div className="flex items-start gap-2 py-1">
    {Icon && <Icon className="w-4 h-4 mt-0.5 flex-shrink-0" style={{ color: '#6B705C' }} />}
    <div className="flex-1 min-w-0">
      <span className="font-body text-xs font-medium" style={{ color: '#6B705C' }}>{label}: </span>
      <span className="font-body text-xs" style={{ color: '#1A3C34' }}>{value}</span>
    </div>
  </div>
);
